<section app-home-carousel></section>
<section app-home-welcome></section>
<section app-home-new-arrivals></section>
<section app-home-best-sellers></section>
<section app-home-products-banner></section>
